const sortOrderTypeEnum = Object.freeze({
  earliestDate: 'earliestDate',
  lowestPrice: 'lowestPrice',
  highestRating: 'highestRating',
  highestDiscount: 'highestDiscount',
});

export default sortOrderTypeEnum;
